import useSWR from 'swr';
import { useIntl } from 'react-intl';
import { useSession } from '../useSession/useSession';
import { useCustomerApi } from '../useCustomerApi/useCustomerApi';

export { PhoneNumberWithTypeTypeEnum } from '@empiriecom/mybuy-frontend-api/backend-mybuy-customer/v1/models/PhoneNumberWithType';
export { Gender } from '@empiriecom/mybuy-frontend-api/backend-mybuy-customer/v1/models/Gender';
export type { CustomerDataWithStatus } from '@empiriecom/mybuy-frontend-api/backend-mybuy-customer/v1/models/CustomerDataWithStatus';

export const useCustomer = () => {
  const { locale } = useIntl();
  const { softLoggedIn, loggedIn } = useSession();
  const customerApi = useCustomerApi();

  const { data: customer, isLoading } = useSWR(
    customerApi && !softLoggedIn && loggedIn ? 'customer' : null,
    () => customerApi!.getCustomer({ ecLocale: locale }),
    { revalidateOnFocus: false },
  );

  return {
    customer,
    isLoading,
  };
};
